<mat-divider></mat-divider>
<footer>
    &copy; All rights reserved 2021
</footer>